import Add from "./Add";
import ArrowRight from "./ArrowRight";
import Award from "./Award";
import Check from "./Check";
import Clock from "./Clock";
import Close from "./Close";
import Date from "./Date";
import Facebook from "./Facebook";
import LinkedIn from "./LinkedIn";
import Location from "./Check";
import Phone from "./Check";
import Spin from "./Spin";
import X from "./X";

export { Add, ArrowRight, Award, Check, Clock, Close, Date, Facebook, LinkedIn, Location, Phone, Spin, X };
